import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import ProfileModalWindow from './ProfileModalWindow'
import { Avatar } from 'rsuite'
import defaultAvatar from './Styles/images/Avatar_placeholder.png'
import { MenuButton, AddButton, DefaultFav } from './Icons'
import './Styles/navigation-bar.css'
import { CSSTransition } from 'react-transition-group'

const NavigationBar = ({ toggleSideBar, isAvatarClicked, setAvatarClicked }) => {
  const match = useLocation()
  const isFavBtnActive = match?.pathname === '/favorites'

  return (
    <>
      <div className='nav-container horizontal-flex' onClick={() => setAvatarClicked(false)}>
        <div style={{ display: 'flex' }}>
          <button className='nav-menu-btn' onClick={toggleSideBar}>
            <MenuButton />
          </button>

          <Link to='/'>
            <div className='brand-name'>
              <span className='taito'>TAITO</span>
              <span className='training'>TRAINING</span>
            </div>
          </Link>
        </div>

        <div id='profile' className='horizontal-flex'>
          <button onClick={e => { window.location.href = '/create' }} className='nav-create-new-event-btn'>
            <AddButton />
            <span className='create' style={{ marginLeft: '10px' }}> Create new event </span>
          </button>

          <Link to='/favorites'>
            <button className={isFavBtnActive
              ? 'nav-favorites-btn-active'
              : 'nav-favorites-btn'}
            >
              <DefaultFav />
            </button>
          </Link>
          <div
            style={{ position: 'relative', height: '40px', width: '40px' }}
          >
            <Avatar
              onClick={(e) => { e.stopPropagation(); setAvatarClicked(!isAvatarClicked) }}
              circle
              className={isAvatarClicked ? 'avatar-border' : 'avatar'}
              src={defaultAvatar}
              alt='UN'
              size='md'
            />
            <CSSTransition
              in={isAvatarClicked}
              timeout={900}
              classNames='alert'
              unmountOnExit
              onEnter={() => setAvatarClicked(true)}
              onExited={() => setAvatarClicked(false)}
            >
              <ProfileModalWindow setAvatarClicked={setAvatarClicked} />
            </CSSTransition>
          </div>
        </div>
      </div>

      {/* <div onClick={() => { setAvatarClicked(false) }}>
        <SideBar isVisible={isNavBtnActive} />
        <MainTab>{children}</MainTab>
      </div> */}
    </>
  )
}

export default NavigationBar
